module.exports = __webpack_public_path__ + "images/emoji/last_quarter_moon_with_face.d8d374bd327942dfeac4.png";